import { UI, HStack, VStack } from '@genial/components';
import { BoxRadius, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Pressable } from 'native-base';
import React from 'react';

import {
  TableContent,
  TableContentItemCaptions,
} from '../../../../../../../../../components/TableContent';
import { getDaysDifferenceFromTodayText } from '../../../../../../../../../utils/getDaysDifferenceFromTodayText';
import { LateralBar } from '../../../../../../../../BatchTicket/components/DynamicAsset/components/Asset/components/LateralBar';
import { useFixedIncomeAssetContext } from '../../../../../../../../BatchTicket/components/DynamicAsset/contexts/products/FixedIncome';
import { useGlobalProductContext } from '../../../../../contexts';

import { FixedIncomeListItemTypes } from '.';

export const FixedIncomeListItemTablet: React.FC<FixedIncomeListItemTypes.Props> = ({ offer }) => {
  const { setModalOpen, setOfferSelected } = useFixedIncomeAssetContext();
  const { product } = useGlobalProductContext();

  const onOpenDetailsModal = () => {
    setModalOpen(true);
    setOfferSelected(offer);
  };

  const middleInfos1 = [
    {
      label: 'Aplic. Min.',
      value: (
        <VStack>
          <UI.Text color="neutral.darkest">
            {Utils.Mask.Money(offer.applicationMinimumAmount)}
          </UI.Text>
          <UI.Text color="neutral.darkest" fontSize={Typography['fontsize.xs']}>
            Max {Utils.Mask.Money(offer.applicationMaximumAmount)}
          </UI.Text>
        </VStack>
      ),
    },
    {
      label: 'Vencimento',
      value: (
        <VStack>
          <UI.Text color="neutral.darkest">{offer.maturityDateNormalized}</UI.Text>
          <UI.Text color="neutral.darkest" fontSize={Typography['fontsize.xs']}>
            {getDaysDifferenceFromTodayText(offer.maturityDate)}
          </UI.Text>
        </VStack>
      ),
    },
    {
      label: 'Carência',
      value: (
        <VStack>
          <UI.Text color="neutral.darkest">{offer.dueDateNormalized}</UI.Text>
          <UI.Text color="neutral.darkest" fontSize={Typography['fontsize.xs']}>
            {getDaysDifferenceFromTodayText(offer.dueDate)}
          </UI.Text>
        </VStack>
      ),
    },
  ];

  const middleInfos2 = [
    {
      label: 'Liquidez',
      value: <UI.Text color="neutral.darkest">{offer.liquidityIndicatorNormalized}</UI.Text>,
    },
    {
      label: 'Taxa',
      value: <UI.Text color="neutral.darkest">{offer.profitabilityFormattedNormalized}</UI.Text>,
    },
    {
      label: 'Rent. até venc.',
      value: (
        <UI.Text color="neutral.darkest">
          {Utils.Mask.Percentage(offer.profitabilityToMaturity)}
        </UI.Text>
      ),
    },
  ];

  return (
    <TableContent direction="row" space={0} p={0} px={Spacing['inline.xxxs']}>
      <LateralBar
        backgroundColor={product.color}
        borderTopLeftRadius={BoxRadius.sm}
        borderBottomLeftRadius={BoxRadius.sm}
      />
      <VStack padding={Spacing['inset.sm']} space={Spacing['stack.xxxs']} w="full">
        <HStack justifyContent="space-between" alignItems="center">
          <VStack space={Spacing['stack.quarck']}>
            <UI.Text variant="semibold" color="neutral.darkest">
              {offer.productDisplayNormalized}
            </UI.Text>
            <TableContentItemCaptions icons={offer.captions} />
          </VStack>
          <Pressable onPress={onOpenDetailsModal}>
            <UI.Icon name="Info" size="xs" />
          </Pressable>
        </HStack>
        <HStack justifyContent="space-between">
          {middleInfos1.map(({ label, value }) => (
            <VStack space={Spacing['stack.quarck']} key={label} w="1/3">
              <UI.Text color="neutral.black" variant="semibold">
                {label}
              </UI.Text>
              {value}
            </VStack>
          ))}
        </HStack>
        <HStack justifyContent="space-between">
          {middleInfos2.map(({ label, value }) => (
            <VStack space={Spacing['stack.quarck']} key={label} w="1/3">
              <UI.Text color="neutral.black" variant="semibold">
                {label}
              </UI.Text>
              {value}
            </VStack>
          ))}
        </HStack>
      </VStack>
    </TableContent>
  );
};
